import { render, staticRenderFns } from "./KYCExceptions.vue?vue&type=template&id=e7185c1c&"
import script from "./KYCExceptions.vue?vue&type=script&lang=js&"
export * from "./KYCExceptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7185c1c')) {
      api.createRecord('e7185c1c', component.options)
    } else {
      api.reload('e7185c1c', component.options)
    }
    module.hot.accept("./KYCExceptions.vue?vue&type=template&id=e7185c1c&", function () {
      api.rerender('e7185c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/KYCExceptions.vue"
export default component.exports